/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtierListItem } from './CourtierListItem';
import {
    CourtierListItemFromJSON,
    CourtierListItemFromJSONTyped,
    CourtierListItemToJSON,
    CourtierListItemToJSONTyped,
} from './CourtierListItem';

/**
 * 
 * @export
 * @interface GetCourtierListResponse
 */
export interface GetCourtierListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCourtierListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<CourtierListItem>}
     * @memberof GetCourtierListResponse
     */
    items: Array<CourtierListItem>;
}

/**
 * Check if a given object implements the GetCourtierListResponse interface.
 */
export function instanceOfGetCourtierListResponse(value: object): value is GetCourtierListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetCourtierListResponseFromJSON(json: any): GetCourtierListResponse {
    return GetCourtierListResponseFromJSONTyped(json, false);
}

export function GetCourtierListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCourtierListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(CourtierListItemFromJSON)),
    };
}

export function GetCourtierListResponseToJSON(json: any): GetCourtierListResponse {
    return GetCourtierListResponseToJSONTyped(json, false);
}

export function GetCourtierListResponseToJSONTyped(value?: GetCourtierListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(CourtierListItemToJSON)),
    };
}

